import * as React from "react";
import { Stack, IStackTokens, IStackStyles, Text, DefaultButton, Link, Spinner, SpinnerSize, mergeStyles, getTheme, FontSizes, FontWeights } from "@fluentui/react";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { IAuthTokenResultDto } from "../interfaces/IAuthTokenResultDto";
import authModule from "../../../utilities/AuthModule";
import { UserLicenseTypeEnum } from "./enums/userLicenseTypeEnum";
import generalModule from "../../../utilities/GeneralModule";
import { shared } from "../config/constants";

const params = new URLSearchParams(window.location.search);

const stackTokens: IStackTokens = {
    childrenGap: 20
};

const stackStyles: IStackStyles = {
    root: {
        height: "100vh",
        padding: 22,
        paddingRight: 22,
        marginTop: 30
    },
};

const stackStylesCM: IStackStyles = {
    root: {
        padding: 25
    },
};

const theme = getTheme();
const textLarge = mergeStyles({
    color: theme.palette.neutralPrimary,
    fontSize: FontSizes.size32,
    fontWeight: FontWeights.light,
});

const textMedium = mergeStyles({
    color: theme.palette.themeDarkAlt,
    fontSize: FontSizes.size24,
    fontWeight: FontWeights.regular,
});

interface TrialRequestProps {
    isLoadingProfile: boolean;
    isAwaitingSignIn?: boolean;
    licenseType: UserLicenseTypeEnum;
    accountName: string;
    setIsAwaitingSignIn?: React.Dispatch<React.SetStateAction<boolean>>;
    onSignInSuccess?: (authResult: IAuthTokenResultDto) => void;
};

export const TrialRequest: React.FC<TrialRequestProps> = ({ isLoadingProfile, isAwaitingSignIn, setIsAwaitingSignIn, onSignInSuccess, licenseType, accountName }) => {
    const languageStrings = React.useContext(LanguageContext);

    const signInCallback = async (authResult: IAuthTokenResultDto) => {
        setIsAwaitingSignIn(false);
        if (authResult) {
            onSignInSuccess(authResult);
        }
    };

    const signInWithADifferentAccount = async () => {
        setIsAwaitingSignIn(true);
        try {
            await authModule.initiateDialogAuthFlow(signInCallback);
        } catch {
            // Ignore
        }
    }

    const redirectToLogin = () => {
        let authUrl: URL = new URL(process.env.baseUri + "/auth.html");
        authUrl.searchParams.append(shared.params.app, "content_manager");
        if (params.has(shared.params.accountId)) {
            authUrl.searchParams.append(shared.params.accountId, params.get(shared.params.accountId));
        }
        if (params.has(shared.params.username)) {
            authUrl.searchParams.append(shared.params.username, params.get(shared.params.username));
        }
        window.location.replace(authUrl);
    };

    return accountName && (
        <Stack styles={generalModule.isInConentMangerMode() ? stackStylesCM : stackStyles} tokens={stackTokens}>
            {<Stack.Item>
                <img style={{ width: "220px", height: "auto", margin: "auto" }} src="./assets/logo.png" alt="Docubird" title="Docubird" />
            </Stack.Item>}
            {/* {!generalModule.isInConentMangerMode() && <Stack.Item>
                <Text className={textLarge}>{languageStrings.Welcome}</Text>
            </Stack.Item>} */}
            {!generalModule.isInConentMangerMode() && <Stack.Item style={{ marginTop: 30 }}>
                <Text className={textMedium}>
                    {Office.context.diagnostics.host === Office.HostType.Outlook ? "Docubird for Outlook" : "Docubird for Office"}
                </Text>
            </Stack.Item>}
            {generalModule.isInConentMangerMode() && <Stack.Item>
                <Text className={textMedium}>
                    Docubird Content Manager
                </Text>
            </Stack.Item>}
            {/* <Stack.Item>
                <Text variant="medium">{languageStrings.WelcomeText}</Text>
            </Stack.Item> */}
            <Stack.Item>
                {licenseType === UserLicenseTypeEnum.Expired && (
                    <Stack tokens={{ childrenGap: 8 }}>
                        <Text variant="medium">{languageStrings.TrialExpiredText}</Text>
                        <Link href="https://www.docubird.com/prijzen" target="_blank">{languageStrings.PriceLinkText}</Link>
                        <Text variant="medium">{languageStrings.ContactUs}</Text>
                    </Stack>
                )}
                {licenseType !== UserLicenseTypeEnum.Expired && (
                    <Stack tokens={{ childrenGap: 8 }}>
                        <Text variant="medium">{languageStrings.AccountDeactivated.replace("{placeholder}", accountName)}</Text>
                    </Stack>
                )}
            </Stack.Item>
            {/* <Stack.Item style={{ marginTop: 25 }}>
                {licenseType === UserLicenseTypeEnum.Expired && <DefaultButton
                    disabled={isAwaitingSignIn || isLoadingProfile}
                    href="https://www.docubird.com/trial"
                    target="_blank"
                    title={languageStrings.RequestTrial}
                    text={isAwaitingSignIn ? languageStrings.SigningIn : (isLoadingProfile ? languageStrings.LoadingProfile : languageStrings.RequestTrial)}
                >
                    {isLoadingProfile && <Spinner size={SpinnerSize.small} />}
                </DefaultButton>}
            </Stack.Item> */}
            {!(isAwaitingSignIn || isLoadingProfile) && <Stack.Item>
                <DefaultButton
                    disabled={isAwaitingSignIn || isLoadingProfile}
                    target="_blank"
                    text={languageStrings.SignInWithDifferentAccount}
                    onClick={() => {
                        if (generalModule.isInConentMangerMode()) {
                            redirectToLogin();
                        } else {
                            signInWithADifferentAccount();
                        }
                    }}
                >
                    {isLoadingProfile && <Spinner size={SpinnerSize.small} />}
                </DefaultButton>
                {/* <Link onClick={() => { 
                    if (generalModule.isInConentMangerMode()) {
                        redirectToLogin();
                    } else {
                        signInWithADifferentAccount();
                    }
                 }} 
                 underline>{languageStrings.SignInWithDifferentAccount}</Link> */}
            </Stack.Item>}
        </Stack>
    );
};